<div class="container">

    <section class='header'>

        <mat-toolbar color='primary' fxLayoutAlign="space-between">
            <div>
                <mat-icon style='margin-top:10px; font-size:.9em;'>store_mall_directory</mat-icon>
                <div style='display:inline-block; margin-left:10px;'>
                    {{ local_title }}
                </div>
            </div>

            <button class="button-close" mat-raised-button mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar>

    </section>

    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">
       
        <div class='tab-content'>

            <mat-form-field class="full-width">
                <input matInput type="text" [errorStateMatcher]="matcher"
                    [formControl]="entityForm.controls.name" placeholder="Nome" autocomplete="off">
                <mat-error *ngIf="entityForm.controls.name.hasError('required')">
                    O nome é obrigatório
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <input matInput type="text" [errorStateMatcher]="matcher"
                    [formControl]="entityForm.controls.email" placeholder="Email" autocomplete="off">
                <mat-error *ngIf="entityForm.controls.email.hasError('required')">
                    O email é obrigatório
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <input matInput type="text" [errorStateMatcher]="matcher"
                    [formControl]="entityForm.controls.cpf" placeholder="CPF" autocomplete="off">
                <mat-error *ngIf="entityForm.controls.cpf.hasError('required')">
                    O CPF é obrigatório.
                </mat-error>
            </mat-form-field>

        </div>
    </form>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button matTooltip='Update' mat-raised-button (click)="matDialogRef.close(['update',entityForm])" [disabled]="entityForm.invalid">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
    </div>

</div>